export interface packageTests {
  packageName: string;
  description: string;
  price: number;
  listOfTest: string[];
}

export interface PackageT {
  listOfTest: string[];
  packageName: string;
  testDescription: string;
  price: number;
  packageCategory: string;
  discount?: number;
  discountTag?: boolean;
  id?: string;
}

export const PackageTests: PackageT[] = [
  {
    listOfTest: ["Liquid Based Cytology", "HPV-DNA", "Pap Smear"],
    packageCategory: "Women's Health",
    testDescription:
      "Secure your cervical health with advanced screening methods like liquid-based cytology, HPV-DNA testing, and Pap smears. Stay guarded against potential risks and maintain your well-being",
    packageName: "Cervix Health ",
    price: 82956.6,
  },
  {
    listOfTest: [
      "Follicle stimulating hormone",
      "Luteinizing hormone",
      "Estradiol",
    ],
    packageCategory: "Women's Health",
    testDescription:
      "Tests such as follicle-stimulating hormone, luteinizing hormone, and estradiol help to inform about hormonal balance ",
    packageName: "Menopausal Screening ",
    price: 21085.44,
  },
  {
    listOfTest: ["Progesterone", "Luteinizing Hormone "],
    packageCategory: "Women's Health",
    testDescription:
      "These tests track ovulation effectively by measuring progesterone levels. ",
    price: 12871.38,
    packageName: "Ovulation Test",
  },
  {
    listOfTest: [
      "Follicle stimulating hormone",
      "Anti-Mullerian Hormone ",
      "Estradiol",
      "Luteinizing Hormone ",
      "Vitamin D",
      "Progesterone",
      "Blood group and Rh",
      "TSH",
    ],
    packageCategory: "Women's Health",
    testDescription:
      "comprehensive panel including follicle-stimulating hormone, anti-Mullerian hormone, estradiol, luteinizing hormone, vitamin D, progesterone, blood group and Rh, and TSH. This test package enhances the understanding for informed family planning.",
    price: 90476.04,
    packageName: "Fertility Panel ",
  },
  {
    listOfTest: [
      "DHEAS",
      "Follicle stimulating hormone",
      "Luteinizing hormone",
      "Estradiol",
      "Prolactin",
      "Testosterone",
      "Thyroid stimulating hormone",
      "Vitamin D",
      "Full Blood Count",
      "Blood group and Rh",
      "Progesterone",
    ],
    packageCategory: "Women's Health",
    testDescription:
      "Tests to address female infertility concerns with a comprehensive panel encompassing DHEAS, follicle-stimulating hormone, estradiol, luteinizing hormone, prolactin, testosterone, thyroid-stimulating hormone, full blood count, vitamin D, progesterone, and blood group/Rh. ",
    price: 67562.76,
    packageName: "Female Infertility Panel ",
  },
  {
    listOfTest: ["Hepatitis B", "Hepatitis C", " HIV 1&2 ", "VDRL"],
    packageCategory: "Sexual Health",
    testDescription:
      ":  For a thorough female STI screening, get tested for hepatitis B and C",
    packageName: "LadyGarden  Women Care",
    price: 18057.06,
  },
  {
    packageName: "LadyGarden Women Care Plus ",
    packageCategory: "Sexual Health",
    listOfTest: [
      "Hepatitis B",
      "Hepatitis C",
      " HIV 1&2 ",
      "Chlamydia",
      "HVS 1&2 Screening",
      "VDRL",
      "HVS",
    ],
    price: 31824,
    testDescription:
      "Prioritize your sexual health with a comprehensive female STI panel, covering hepatitis B and C, HIV 1 & 2, Chlamydia, HSV 1 & 2 screening, HVS, and VDRL. Be informed and take proactive steps for a healthier, confident lifestyle.",
  },
  {
    listOfTest: [
      "Hepatitis B",
      "Hepatitis C",
      "HIV 1&2",
      "Chlamydia",
      "HPV-DNA",
      "HVS",
      "Herpes Simplex Virus Type 1  IgG Ab",
      "Herpes Simplex Virus Type 2  IgG Ab",
      "VDRL",
    ],
    packageCategory: "Sexual Health",
    testDescription:
      "Improve your sexual health awareness with a thorough female STI panel, encompassing hepatitis B and C, HIV 1 & 2, Chlamydia, HPV-DNA, HVS (Herpes Simplex Virus) type 1 IgG Ab, HVS type 2 IgG Ab, and VDRL.",
    packageName: " LadyGarden Women Care Max",
    price: 45173.76,
  },
  {
    listOfTest: ["PSA Free", "PSA Total"],
    packageCategory: "Men's Health",
    testDescription:
      "Prioritize prostate care with a holistic approach, including tests for creatine kinase, lactate dehydrogenase (LDH), magnesium, TSH, vitamin B12, and a full blood count. Stay proactive in maintaining your overall well-being and supporting prostate health.",
    packageName: "Prostrate Care",
    price: 28598.76,
  },
  {
    listOfTest: [
      "Albumin",
      "FSH",
      "LH",
      "Testosterone",
      "Fasting Glucose",
      "E2",
    ],
    packageCategory: "Men's Health",
    testDescription:
      "Optimize your male fertility health with a comprehensive test panel including albumin, FSH, LH, testosterone, fasting glucose, and E2 (estradiol). Stay informed about key factors affecting fertility for a proactive approach to reproductive health.",
    packageName: "Male Fertility Panel",
    price: 34002.72,
  },

  {
    listOfTest: [
      "Zinc",
      "Haemoglobin",
      "Ferritin",
      "C-Reactive Protein",
      "Creatine Kinase",
      "Lactate Dehydrogenase (LDH)",
      "Magnesium",
      "TSH",
      "Vitamin B12",
      "Vitamin D3",
      "Full Blood Count",
    ],
    packageCategory: "Men's Health",
    testDescription:
      "Optimize your male fertility health with a comprehensive test panel including albumin, FSH, LH, testosterone, fasting glucose, and E2 (estradiol). Stay informed about key factors affecting fertility for a proactive approach to reproductive health.",
    packageName: "Fit Men ",
    price: 92514,
  },
  {
    listOfTest: [
      "Zinc",
      "Haemoglobin",
      "Ferritin",
      "C-Reactive Protein",
      "Creatine Kinase",
      "Lactate Dehydrogenase (LDH)",
      "Magnesium",
      "TSH",
      "Vitamin B12",
      "Vitamin D3",
      "Full Blood Count",
    ],
    packageCategory: "Men's Health",
    testDescription:
      "Promote men's health with a comprehensive panel including zinc, hemoglobin, ferritin, C-reactive protein, herpes simplex virus type 1 IgG Ab, type 2 IgG Ab, VDRL, and urethral swab. Stay proactive in addressing both general well-being and specific health markers for a holistic approach to men's health",
    packageName: "Fit Men Max ",
    price: 123318,
  },
  {
    listOfTest: ["Hepatitis B", "Hepatitis C", "HIV 1&2", "VDRL"],
    packageCategory: "Sexual Health",
    testDescription:
      "Prioritize your sexual health with a focused male STI panel covering hepatitis B and C, HIV 1 & 2, and VDRL. Stay informed and take proactive steps to ensure a healthier and confident lifestyle.",
    packageName: "Hercules Men",
    price: 18057.06,
  },

  {
    listOfTest: [
      "Hepatitis B",
      "Hepatitis C",
      "HIV 1&2",
      "HSV1&2 screening",
      "Urethral swab",
      "VDRL",
    ],
    packageCategory: "Sexual Health",
    testDescription:
      "Take control of your sexual health with a thorough male STI panel, including hepatitis B and C, HIV 1 & 2, Chlamydia, HVS 1 & 2 screening, urethral swab, and VDRL. ",
    packageName: "Hercules Men Plus ",
    price: 38509.08,
  },

  {
    listOfTest: [
      "Hepatitis B",
      "Hepatitis C",
      "HIV 1&2",
      "Chlamydia",
      "Herpes Simplex Virus Type 1  IgG Ab",
      "Herpes Simplex Virus Type 2  IgG Ab",
      "VDRL",
      "Urethral swab",
    ],
    packageCategory: "Sexual Health",
    testDescription:
      "Prioritize your sexual health with a comprehensive male STI panel, covering hepatitis B and C, HIV 1 & 2, Chlamydia, along with assessments for calcium, ESR, urinalysis, and BMI. Stay proactive in maintaining overall well-being and addressing key health markers.",
    packageName: "Hercules Men Max ",
    price: 45173.76,
  },

  {
    listOfTest: [
      "Full Blood count",
      "Renal Function test",
      "Blood sugar",
      "Lipid profile",
      "Urinalysis",
      "ESR",
      "Pap smear",
      "HbA1C",
      "CEA",
      "BMI",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Elevate your general wellness with a comprehensive panel tailored for females, encompassing full blood count, renal function test, blood sugar, lipid profile, and urinalysis, ESR, Pap smear, HbA1C, CEA, and BMI. Stay proactive in managing your health and ensuring overall well-being.",
    packageName: "Tinsel Mini Women ",
    price: 53413.32,
  },

  {
    listOfTest: [
      "Full Blood count",
      "Liver Function test",
      "Blood sugar",
      "Lipid profile",
      "HIV 1 & 2 screening",
      "ESR",
      "Pap smear",
      "Calcium",
      "CEA",
      "BMI",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Elevate your general wellness with a comprehensive panel tailored for females, encompassing full blood count, renal function test, blood sugar, lipid profile, and urinalysis, ESR, Pap smear, HbA1C, CEA, and BMI. Stay proactive in managing your health and ensuring overall well-being.",
    packageName: "Jingle Mini Women ",
    price: 35506.2,
  },

  {
    listOfTest: [
      "Full Blood count",
      "Liver Function test",
      "Stool analysis",
      "Blood sugar",
      "Urinalysis",
      "Pap smear",
      "BMI",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Elevate your general wellness with a comprehensive panel tailored for females, encompassing full blood count, renal function test, blood sugar, lipid profile, and urinalysis, ESR, Pap smear, HbA1C, CEA, and BMI. Stay proactive in managing your health and ensuring overall well-being.",
    packageName: "Noel Mini Women",
    price: 24132.18,
  },

  {
    listOfTest: [
      "Full Blood Count",
      "Renal function Test",
      "Liver Function Test",
      "Blood Sugar",
      "Lipid Profile",
      "Urinalysis",
      "ESR",
      "Stool Analysis",
      "Thyroid Function Test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      "HIV 1&2 Screening",
      "ESR",
      "BMI",
      "Hepatitis C Screening",
      "Pap Smear",
      "HbA1C",
      "Vitamin B12",
      "CEA",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Prioritize your overall well-being with a comprehensive female wellness panel. Stay proactive in managing your health with these essential screenings listed above.",
    packageName: "Jingle Women ",
    price: 102928.2,
    discount: 10,
    discountTag: true,
  },
  {
    listOfTest: [
      " Full Blood Count",
      "Renal function Test",
      "Liver Function Test",
      " Blood Sugar",
      "Lipid Profile",
      "Urinalysis",
      "ESR",
      "Stool Analysis",
      "Thyroid Function Test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      "HIV 1&2 Screening",
      "Uric Acid",
      "BMI",
      "Hepatitis C Screening",
      "Pap Smear",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Nurture your well-being with a comprehensive female wellness panel, covering full blood count, stool analysis, liver function tests, blood sugar, urinalysis, Pap smear, BMI and others listed above. Stay proactive in managing your health for a holistic approach to well-being",
    packageName: "Noel Women ",
    price: 67645.38,
    discount: 10,
    discountTag: true,
  },
  {
    listOfTest: [
      "Full Blood Count",
      "Renal function Test",
      "Liver Function Test",
      " Blood Sugar",
      " Lipid Profile",
      "Urinalysis",
      "ESR",
      "Stool Analysis",
      " Thyroid Function Test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      " HIV 1&2 Screening",
      "Uric Acid",
      "BMI",
      "Hepatitis C Screening",
      "Pap Smear",
      "HbA1C",
      "Vitamin B12",
      "CEA",
      "HPV DNA",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Elevate your general wellness with a comprehensive panel tailored for females, comprising of the tests above. Stay proactive in managing your health and ensuring overall well-being.",
    packageName: "Tinsel Women ",
    price: 159028.2,
    discount: 10,
    discountTag: true,
  },
  {
    listOfTest: [
      "Full Blood Count",
      "Renal function Test",
      "Liver Function Test",
      "Blood Sugar",
      "Lipid Profile",
      "Urinalysis",
      "ESR",
      "Stool Analysis",
      "Thyroid Function Test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      "HIV 1&2 Screening",
      "Uric Acid",
      "BMI",
      "Hepatitis C Screening",
      "PSA",
      "HbA1C",
      "Vitamin B12",
      "AFP",
    ],
    packageCategory: "December Packages",
    testDescription:
      " Prioritize your overall wellness with a comprehensive male health panel, including full blood count, blood sugar, stool analysis, BMI, liver function tests, renal function tests, calcium, phosphorus, HbsAg, uric acid, PSA, etc. Stay proactive in managing your health for a holistic and well-rounded approach.",
    packageName: "Herald Men",
    price: 95269.12,
    discount: 10,
    discountTag: true,
  },
  {
    listOfTest: [
      "Full Blood Count",
      "Renal function Test",
      "Liver Function Test",
      "Blood Sugar",
      "Lipid Profile",
      "Urinalysis",
      "ESR",
      "Stool Analysis",
      "Thyroid Function Test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      "HIV 1&2 Screening",
      "Uric Acid",
      "BMI",
      "Hepatitis C Screening",
      "PSA",
      "HbA1C",
      "Vitamin B12",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Prioritize your male wellness with a comprehensive panel, including full blood count, renal function tests, blood sugar, lipid profile, uric acid, stool analysis, BMI, HIV 1 & 2 screening, liver function tests, hepatitis B assessment and others listed above. Stay proactive in managing your health for overall well-being.",
    packageName: " Shepherd Men ",
    price: 96674.58,
    discount: 10,
    discountTag: true,
  },
  {
    listOfTest: [
      "Full Blood Count",
      " Renal function Test",
      "Liver Function Test",
      "Blood Sugar",
      "Lipid Profile",
      "Urinalysis",
      "ESR",
      "Stool Analysis",
      "Thyroid Function Test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      "HIV 1&2 Screening",
      "Uric Acid",
      "BMI",
      "Hepatitis C Screening",
      "PSA",
      "HbA1C",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Boost your overall wellness with a thorough male health panel, featuring full blood count, blood sugar, liver function tests, HIV 1 & 2 screening, uric acid, BMI, Hepatitis C screening, stool analysis, ESR, calcium, etc. Stay proactive in managing your health for a comprehensive and balanced approach.",
    packageName: "Patridge Men ",
    price: 83210.58,
    discount: 10,
    discountTag: true,
  },
  {
    listOfTest: [
      "Full Blood count",
      "Blood sugar",
      "Stool analysis",
      "BMI",
      "Liver Function test",
      "Renal Function test",
      "Calcium",
      "Phosphorus",
      "HbsAg",
      "Uric acid",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Prioritize your overall wellness with a mini comprehensive male health panel, which includes full blood count, blood sugar, stool analysis, BMI, liver function tests, renal function tests, calcium, phosphorus, HbsAg, uric acid, and PSA. ",
    packageName: "Herald Mini Men ",
    price: 45314.52,
  },
  {
    listOfTest: [
      "Full Blood count",
      "Blood sugar",
      "Liver Function test",
      "HIV 1 & 2 screening",
      "Uric Acid",
      "BMI",
      "Hepatitis C screening",
      " Stool analysis",
      "ESR",
      " Calcium",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Boost your overall wellness with an affordable male health panel, featuring full blood count, blood sugar, liver function tests, HIV 1 & 2 screening, uric acid, BMI, Hepatitis C screening, stool analysis, ESR, and calcium. Stay proactive in managing your health for a comprehensive and balanced approach.",
    packageName: "Patridge Mini Men ",
    price: 20828.4,
  },
  {
    listOfTest: [
      "Full Blood count",
      "Renal Function test",
      "Blood sugar",
      "Lipid profile",
      "Uric acid",
      "Stool analysis",
      "BMI",
      "HIV 1 & 2 screening",
      "Liver Function",
      "Hepatitis B",
    ],
    packageCategory: "December Packages",
    testDescription:
      "Prioritize your male wellness with a mini comprehensive panel, including full blood count, renal function tests, blood sugar, lipid profile, uric acid, stool analysis, BMI, HIV 1 & 2 screening, liver function tests, and hepatitis B assessment. Stay proactive in managing your health for overall well-being.",
    packageName: "Shepherd Mini Men ",
    price: 34030.42,
  },
  //General Wellness Male
];
